import { useQuery } from '@tanstack/react-query';
import { reportService } from '../../services/api/reportService';

/**
 * Client-safe free report for an application (null when none exists).
 * Read-only — reports are produced and sent by the CRM, never by clients.
 */
export function useReportQuery(applicationId) {
  return useQuery({
    queryKey: ['report', applicationId],
    queryFn: () => reportService.getByApplicationId(applicationId),
    enabled: !!applicationId,
    staleTime: 60 * 1000,
    retry: false,
  });
}
